import React from 'react'
import {
  ImageWithTextComponent, 
  InformationComponent, 
  SliderComponent, 
  TableComponent, 
  TextComponent, 
  ImageComponent,
  AccentBlockComponent,
  CheckAlgorithmComponent,
  SupplierTricksSimpleComponent,
  SupplierTricksComponent
} from './components'

const HowChoiceSwitch = ({component_type , properties}) => {
  switch (component_type) {
    case "TextComponent":
      return <TextComponent {...properties}/>
    case "TableComponent":
      return <TableComponent {...properties}/>
    case "ImageComponent":
      return <ImageComponent {...properties} />
    case "SliderComponent":
      return <SliderComponent {...properties} />
    case "AccentBlockComponent":
      return <AccentBlockComponent {...properties} />
    case "InformationComponent":
      return <InformationComponent {...properties} />
    case "ImageWithTextComponent":
      return <ImageWithTextComponent {...properties} />
    case "SupplierTricksComponent":
      return <SupplierTricksComponent {...properties} />
    case "CheckAlgorithmComponent":
      return <CheckAlgorithmComponent {...properties} />
    case "SupplierTricksSimpleComponent":
      return <SupplierTricksSimpleComponent {...properties} />
    default:
      return null
  }
}

export default HowChoiceSwitch